import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    items: [],
    isFetchingPage: false,
    isInitialLoading: true,
    isLoadingProcesses: false,
    isUpdating: false,
    status: "idle",
    links: {},
    error: null,
    meta: {},
    currentPage: 1,
};

const recruitmentProcessesSlice = createSlice({
    name: "processes",
    initialState,
    reducers: {
        initialLoadStarted(state) {
            state.isInitialLoading = true;
            state.status = "loading";
            state.currentPage = initialState.currentPage;
        },
        processesRequested(state, _action) {
            state.isFetchingPage = true;
            state.isLoadingProcesses = true;
            state.status = "loading";
        },
        processesReceived(state, action) {
            const { data = [], links = {}, meta = {} } = action.payload || {};
            state.isLoadingProcesses = false;
            state.isFetchingPage = false;
            state.isInitialLoading = false;
            state.status = "success";
            state.items = data;
            state.links = links;
            state.meta = meta;
        },
        processesFailed(state, action) {
            state.status = "failed";
            state.error = action.payload || "Request failed";
            state.isLoadingProcesses = false;
            state.isFetchingPage = false;
            state.isInitialLoading = false;
        },

        processAdded(state, action) {
            const { data = [], links = {}, meta = {} } = action.payload || {};
            state.status = "success";
            state.items = data;
            state.links = links;
            state.meta = meta;
            state.isLoadingProcesses = false;
        },
        mutationStarted(state, _action) {
            state.isLoadingProcesses = true;
        },
        mutationCompleted(state, _action) {
            state.isLoadingProcesses = false;
        },
        pageChangeStarted(state, _action) {
            state.isFetchingPage = true;
        },
        pageChanged(state, action) {
            state.currentPage = action.payload;
            state.isFetchingPage = false;
        },
        updateStarted(state) {
            state.isUpdating = true;
        },
        updateCompleted(state) {
            state.isUpdating = false;
        },
    },
});

export const {
    processesRequested,
    processesReceived,
    initialLoadStarted,
    processesFailed,
    processAdded,
    pageChangeStarted,
    mutationStarted,
    mutationCompleted,
    pageChanged,
    updateStarted,
    updateCompleted,
} = recruitmentProcessesSlice.actions;

export default recruitmentProcessesSlice.reducer;
